import { useTranslation } from '../../i18n';

interface LoadingIndicatorProps {
  message?: string;
  fullScreen?: boolean;
  // Size prop is removed as the bouncing dots have a fixed size, or can be scaled via parent font-size or a new specific prop if needed.
  // For now, keeping it simple.
}

export function LoadingIndicator({ 
  message, 
  fullScreen = false 
}: LoadingIndicatorProps) {
  const { t } = useTranslation();
  
  const containerClasses = fullScreen 
    ? 'flex flex-col justify-center items-center min-h-screen bg-gray-50 dark:bg-gray-900' // Added bg for fullscreen
    : 'flex flex-col justify-center items-center py-8';

  const defaultMessage = t('common.loading', 'Loading...');

  return (
    <div className={containerClasses}>
      <div className="flex space-x-2 mb-4">
        <div className="w-3 h-3 bg-blue-500 rounded-full bouncing-dot"></div>
        <div className="w-3 h-3 bg-blue-500 rounded-full bouncing-dot"></div>
        <div className="w-3 h-3 bg-blue-500 rounded-full bouncing-dot"></div>
      </div>
      <p className="text-lg text-gray-600 dark:text-gray-400">
        {message || defaultMessage}
      </p>
    </div>
  );
}